<template><section><h1>Change Log</h1>
<p><a name="2.14.0"></a></p>
<h1><a href="https://github.com/Endebert/squadmc/compare/v2.12.3...v2.14.0">2.14.0</a> (2020-12-27)</h1>
<h3>Features</h3>
<ul>
<li>implemented vue-router for maps (<a href="https://github.com/Endebert/squadmc/issues/94">#94</a>) (by ekzyis) (<a href="https://github.com/Endebert/squadmc/commit/30578cb">30578cb</a>)</li>
</ul>
<p><a name="2.13.2"></a></p>
<h2><a href="https://github.com/Endebert/squadmc/compare/v2.13.0...v2.13.2">2.13.2</a> (2020-10-09)</h2>
<h3>Bug Fixes</h3>
<ul>
<li>added Netlify badge to navigation drawer (<a href="https://github.com/Endebert/squadmc/commit/e96d97c">e96d97c</a>)</li>
</ul>
<p><a name="2.13.1"></a></p>
<h2><a href="https://github.com/Endebert/squadmc/compare/v2.13.0...v2.13.1">2.13.1</a> (2020-08-29)</h2>
<h3>Bug Fixes</h3>
<ul>
<li>Added cache-control immutable header (by Trikolon) (<a href="https://github.com/Endebert/squadmc/commit/c4600cc">c4600cc</a>)</li>
<li>fix not using nato mils in squad (<a href="https://github.com/Endebert/squadmc/commit/889f678">889f678</a>)</li>
</ul>
<p><a name="2.13.0"></a></p>
<h1><a href="https://github.com/Endebert/squadmc/compare/v2.12.3...v2.13.0">2.13.0</a> (2020-08-29)</h1>
<h3>Bug Fixes</h3>
<ul>
<li><strong>PostScriptum:</strong> update mortar velocities (by ansarto) (<a href="https://github.com/Endebert/squadmc/commit/3538f89">3538f89</a>)</li>
</ul>
<h3>Features</h3>
<ul>
<li>switch between regular Milliradian and NATO Milliradian based on game (<a href="https://github.com/Endebert/squadmc/commit/e8794e0">e8794e0</a>)</li>
</ul>
<p><a name="2.12.3"></a></p>
<h2><a href="https://github.com/Endebert/squadmc/compare/v2.12.2...v2.12.3">2.12.3</a> (2020-02-24)</h2>
<h3>Bug Fixes</h3>
<ul>
<li>fixed pins in target selection missing + state handling (<a href="https://github.com/Endebert/squadmc/commit/a52214f">a52214f</a>)</li>
</ul>
<p><a name="2.12.2"></a></p>
<h2><a href="https://github.com/Endebert/squadmc/compare/v2.12.1...v2.12.2">2.12.2</a> (2020-01-18)</h2>
<h3>Bug Fixes</h3>
<ul>
<li>updated PostScriptum mortar ranges (<a href="https://github.com/Endebert/squadmc/commit/6c5fa85">6c5fa85</a>)</li>
</ul>
<p><a name="2.12.1"></a></p>
<h2><a href="https://github.com/Endebert/squadmc/compare/v2.12.0...v2.12.1">2.12.1</a> (2020-01-11)</h2>
<h3>Bug Fixes</h3>
<ul>
<li>updated PostScriptum mortar ranges (<a href="https://github.com/Endebert/squadmc/commit/923cb42">923cb42</a>)</li>
</ul>
<p><a name="2.12.0"></a></p>
<h1><a href="https://github.com/Endebert/squadmc/compare/v2.11.0...v2.12.0">2.12.0</a> (2019-01-19)</h1>
<h3>Features</h3>
<ul>
<li>add 6cm mortar option for PS US airborne faction (<a href="https://github.com/Endebert/squadmc/issues/38">#38</a>) (by TopMak) (<a href="https://github.com/Endebert/squadmc/commit/9913354">9913354</a>)</li>
</ul>
<p><a name="2.11.0"></a></p>
<h1><a href="https://github.com/Endebert/squadmc/compare/v2.10.1...v2.11.0">2.11.0</a> (2018-10-17)</h1>
<h3>Bug Fixes</h3>
<ul>
<li>fixed changelog-dialog close button position (<a href="https://github.com/Endebert/squadmc/commit/29d0cce">29d0cce</a>)</li>
<li>fixed FOB markers not being removed when trying to remove them in the navbar (<a href="https://github.com/Endebert/squadmc/issues/34">#34</a>) (by TopMak) (<a href="https://github.com/Endebert/squadmc/commit/6251785">6251785</a>)</li>
<li>fixed not catching an error when drawing on the map canvas (<a href="https://github.com/Endebert/squadmc/commit/c578791">c578791</a>)</li>
</ul>
<h3>Features</h3>
<ul>
<li>added error reporting functionality (<a href="https://github.com/Endebert/squadmc/commit/872e431">872e431</a>)</li>
<li>added showing changelog dialog when using newer version for the first time (<a href="https://github.com/Endebert/squadmc/commit/92b7a14">92b7a14</a>)</li>
<li>Improved Caching (<a href="https://github.com/Endebert/squadmc/issues/33">#33</a>) (by Trikolon) (<a href="https://github.com/Endebert/squadmc/commit/0a06a56">0a06a56</a>)</li>
</ul>
<p><a name="2.10.1"></a></p>
<h2><a href="https://github.com/Endebert/squadmc/compare/v2.10.0...v2.10.1">2.10.1</a> (2018-09-30)</h2>
<h3>Bug Fixes</h3>
<ul>
<li>fixed using non-letter keypad characters after Z (by TopMak) (<a href="https://github.com/Endebert/squadmc/commit/73f93aa">73f93aa</a>)</li>
</ul>
<p><a name="2.10.0"></a></p>
<h1><a href="https://github.com/Endebert/squadmc/compare/v2.9.0...v2.10.0">2.10.0</a> (2018-09-28)</h1>
<h3>Bug Fixes</h3>
<ul>
<li>fixed errors &amp; strange behaviour when deleting a target from map while using LINE/AREA fire mode (<a href="https://github.com/Endebert/squadmc/commit/69c92ab">69c92ab</a>)</li>
</ul>
<h3>Features</h3>
<ul>
<li>use modern flag to build production files (by Trikolon) (<a href="https://github.com/Endebert/squadmc/issues/30">#30</a>) (<a href="https://github.com/Endebert/squadmc/commit/70842c4">70842c4</a>)</li>
<li>Vuetify a la carte, to further reduce app size (by Trikolon) (<a href="https://github.com/Endebert/squadmc/commit/43a6f52">43a6f52</a>)</li>
</ul>
<p><a name="2.9.0"></a></p>
<h1><a href="https://github.com/Endebert/squadmc/compare/v2.8.0...v2.9.0">2.9.0</a> (2018-09-22)</h1>
<h3>Bug Fixes</h3>
<ul>
<li>fixed layout issue in navbar title (<a href="https://github.com/Endebert/squadmc/commit/dfdd7f3">dfdd7f3</a>)</li>
<li>replaced font &quot;Roboto Mono&quot; with &quot;Hack&quot; for better monospace &amp; unicode text/symbols (<a href="https://github.com/Endebert/squadmc/commit/5868abb">5868abb</a>)</li>
</ul>
<h3>Features</h3>
<ul>
<li>added app name &amp; version to splash/loading screen (<a href="https://github.com/Endebert/squadmc/commit/778e529">778e529</a>)</li>
<li>LINE &amp; AREA fire; by Kalliser (<a href="https://github.com/Endebert/squadmc/commit/6f01033">6f01033</a>)</li>
<li>performance improvements through canvas rendering (<a href="https://github.com/Endebert/squadmc/commit/149bb9d">149bb9d</a>)</li>
</ul>
<p><a name="2.8.0"></a></p>
<h1><a href="https://github.com/Endebert/squadmc/compare/v2.7.1...v2.8.0">2.8.0</a> (2018-08-09)</h1>
<h3>Bug Fixes</h3>
<ul>
<li>added &quot;Close&quot; button to changelog dialog (<a href="https://github.com/Endebert/squadmc/commit/ae09ef6">ae09ef6</a>)</li>
<li>added hint to icon buttons in add mortar/target dialog (<a href="https://github.com/Endebert/squadmc/commit/c85de1d">c85de1d</a>)</li>
<li>added polyfill for CustomEvent (<a href="https://github.com/Endebert/squadmc/commit/b83266c">b83266c</a>)</li>
<li>adjusted PostScriptum GER 8CM mortar velocity and resulting max distance (<a href="https://github.com/Endebert/squadmc/commit/20dcf76">20dcf76</a>)</li>
<li>allow navigation drawer to be swiped out, but not in (<a href="https://github.com/Endebert/squadmc/commit/99cf255">99cf255</a>)</li>
<li>changed floating action button color (<a href="https://github.com/Endebert/squadmc/commit/e8cdd39">e8cdd39</a>)</li>
<li>fixed &quot;+&quot; icon not being centered in floating action button (<a href="https://github.com/Endebert/squadmc/commit/8b539f2">8b539f2</a>)</li>
<li>fixed map not being centered properly on initial page load (<a href="https://github.com/Endebert/squadmc/commit/87b36a4">87b36a4</a>)</li>
<li>fixed menu button not being perfectly circular (<a href="https://github.com/Endebert/squadmc/commit/5482b1d">5482b1d</a>)</li>
<li>fixed needing to reset map when switching off Advanced Mode (<a href="https://github.com/Endebert/squadmc/commit/445bc62">445bc62</a>)</li>
<li>fixed top-left mortar/target buttons in Quick Mode (<a href="https://github.com/Endebert/squadmc/commit/432930e">432930e</a>)</li>
<li>set max-width for changelog dialog (<a href="https://github.com/Endebert/squadmc/commit/ef728cd">ef728cd</a>)</li>
<li>updated mortar velocities (<a href="https://github.com/Endebert/squadmc/commit/df76862">df76862</a>)</li>
</ul>
<h3>Features</h3>
<ul>
<li>added &quot;Advanced Mode&quot; by inverting &quot;Quick Mode&quot; (<a href="https://github.com/Endebert/squadmc/commit/bff3d38">bff3d38</a>)</li>
<li>allow hiding loading indicator in toolbar (now hidden by default) (<a href="https://github.com/Endebert/squadmc/commit/f1e0a6f">f1e0a6f</a>)</li>
<li>rearranged options in navigation drawer (<a href="https://github.com/Endebert/squadmc/commit/d42365a">d42365a</a>)</li>
</ul>
<p><a name="2.7.2"></a></p>
<h2><a href="https://github.com/Endebert/squadmc/compare/v2.7.1...v2.7.2">2.7.2</a> (2018-07-18)</h2>
<h3>Bug Fixes</h3>
<ul>
<li>added &quot;Close&quot; button to changelog dialog (<a href="https://github.com/Endebert/squadmc/commit/ae09ef6">ae09ef6</a>)</li>
<li>added polyfill for CustomEvent (<a href="https://github.com/Endebert/squadmc/commit/b83266c">b83266c</a>)</li>
<li>adjusted PostScriptum GER 8CM mortar velocity and resulting max distance (<a href="https://github.com/Endebert/squadmc/commit/20dcf76">20dcf76</a>)</li>
<li>set max-width for changelog dialog (<a href="https://github.com/Endebert/squadmc/commit/ef728cd">ef728cd</a>)</li>
</ul>
<p><a name="2.7.1"></a></p>
<h2><a href="https://github.com/Endebert/squadmc/compare/v2.7.0...v2.7.1">2.7.1</a> (2018-07-06)</h2>
<h3>Bug Fixes</h3>
<ul>
<li>fixed bottom left keypad indicator not disappearing after 1 second on desktop (<a href="https://github.com/Endebert/squadmc/commit/4b25739">4b25739</a>)</li>
</ul>
<p><a name="2.7.0"></a></p>
<h1><a href="https://github.com/Endebert/squadmc/compare/v2.6.0...v2.7.0">2.7.0</a> (2018-07-06)</h1>
<h3>Bug Fixes</h3>
<ul>
<li>fixed version button being clipped in PostScriptum mode (<a href="https://github.com/Endebert/squadmc/commit/f980e8e">f980e8e</a>)</li>
</ul>
<h3>Features</h3>
<ul>
<li>merged PostScriptum extensions into main branch for easier maintenance (<a href="https://github.com/Endebert/squadmc/commit/30988bc">30988bc</a>)</li>
</ul>
<p><a name="2.6.0"></a></p>
<h1><a href="https://github.com/Endebert/squadmc/compare/v2.5.0...v2.6.0">2.6.0</a> (2018-07-04)</h1>
<h3>Bug Fixes</h3>
<ul>
<li>added css fix for compatibility with mobile safari 8 (<a href="https://github.com/Endebert/squadmc/commit/9caded1">9caded1</a>)</li>
<li>added performance-polyfill to prevent exception thrown by Vuetify (<a href="https://github.com/Endebert/squadmc/commit/7087ed7">7087ed7</a>)</li>
<li>fixed incorrect keypad to latlng conversion (<a href="https://github.com/Endebert/squadmc/commit/6828d45">6828d45</a>)</li>
</ul>
<h3>Features</h3>
<ul>
<li>added pin placement by keypad input dialog (bottom right button) (<a href="https://github.com/Endebert/squadmc/commit/61aefcc">61aefcc</a>)</li>
</ul>
<p><a name="2.5.0"></a></p>
<h1>2.5.0 (2018-07-02)</h1>
<p>Reset repository, since cloning it required download of &gt;800mb. This gets rid of old versions containing map files.</p>
</section></template><script>export default {components:{}}</script>